import { useEffect, useRef } from 'react';
import { iconUrl } from '#/utils/assetUrl';

const STEPS = [
  {
    num: 1,
    icon: 'method-step-1.png',
    title: '삼쩜삼 앱 열기',
    desc: '혜택알리미 메뉴로\n이동하세요',
    fill: true,
  },
  {
    num: 2,
    icon: 'method-step-2.png',
    title: '내 조건 입력',
    desc: '간단한 설문으로 맞춤\n조건을 설정해요',
    fill: true,
  },
  {
    num: 3,
    icon: 'method-step-3.png',
    title: '맞춤 혜택 확인',
    desc: '나에게 딱 맞는 혜택\n목록을 확인하세요',
    fill: false,
  },
  {
    num: 4,
    icon: 'method-step-4.png',
    title: '바로 신청하기',
    desc: '혜택 목록에서\n바로 신청까지!',
    fill: false,
  },
] as const;

function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const prefersReduced = window.matchMedia?.(
      '(prefers-reduced-motion: reduce)'
    )?.matches;
    if (prefersReduced) {
      el.classList.add('revealed');
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('revealed');
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return ref;
}

type UsageStepsProps = {
  /** Tighter top spacing when placed directly below hero-orbital */
  afterOrbital?: boolean;
};

export default function UsageSteps({ afterOrbital = false }: UsageStepsProps) {
  const stepsRef = useReveal();

  return (
    <section className={`steps${afterOrbital ? ' steps--after-orbital' : ''}`}>
      <div ref={stepsRef} className="steps-inner reveal-group">
        <div className="steps-header reveal-child">
          <h2 className="steps-title">이용 방법</h2>
          <div className="steps-gap-12" />
          <p className="steps-subtitle">
            아래 4가지 단계를 통해 내게 맞는 혜택을 신속하게 확인할 수 있어요
          </p>
        </div>
        <div className="steps-gap-48" />
        <div className="steps-row">
          {STEPS.map((s, i) => (
            <div
              key={s.num}
              className="step-item reveal-child"
              style={{ '--reveal-i': i + 1 } as React.CSSProperties}
            >
              <div className="step-icon-wrap">
                <img
                  className={`step-icon${s.fill ? ' step-icon--fill' : ''}`}
                  src={iconUrl(s.icon)}
                  alt={s.title}
                />
              </div>
              <span className="step-tag">STEP {s.num}</span>
              <div className="step-text">
                <h4 className="step-text-title">{s.title}</h4>
                <p className="step-text-desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
